import React, { useEffect, useState } from "react";
import useApiClient, { apiRoutes } from "../../../../hooks/apiClient";
import HtmlToString from "../../../../components/Formatters/HtmlToString";

const useSubstituirTexto = ({ dadosOs, atividade }) => {
  const [valorBoolean, setValorBoolean] = useState(false);
  const [show, setShow] = useState({
    body: null,
    show: false,
  });
  const {
    request: substituirRequest,
    data: substituirData,
    errors: substituirErrors,
    isLoading: substituirIsLoading,
  } = useApiClient();

  const substituirTextoComunicado = (value, textoPadrao) => {
    if (
      atividade?.siglaAtividade === "A4" ||
      atividade?.siglaAtividade === "A8" ||
      atividade?.siglaAtividade === "A9"
    ) {
      substituirRequest(apiRoutes.fiscalizacao.alteracaoexecutor.substituirTexto, {
        textoAndamento: textoPadrao,
        sqAlteracaoExecutor: value,
        sqAtividade: atividade.sequencialAtividade,
      });
    } else {
      substituirRequest(apiRoutes.fiscalizacao.ordemservico.substituirTexto, {
        textoComunicado: textoPadrao,
        sqAcaoFiscal: dadosOs.acaoFiscal,
        sqComunicado: dadosOs.sequencialComunicado > 0 ? dadosOs.sequencialComunicado : 0,
      });
    }
    setValorBoolean(value);
  };

  useEffect(() => {
    let texto = "";

    if (substituirIsLoading) return;

    if (substituirErrors) return;

    if (substituirData) {
      if (valorBoolean) {
        texto = (
          <div>
            <HtmlToString html={substituirData.result} />
          </div>
        );
      } else {
        texto = substituirData.result;
      }

      setShow({
        body: texto,
        show: valorBoolean,
      });
    }
  }, [substituirIsLoading, substituirData, setShow, valorBoolean, substituirErrors]);

  return { substituirTextoComunicado, show, setShow, substituirIsLoading, substituirErrors };
};

export default useSubstituirTexto;
